<template>
    <el-form label-width="80px" label-position="right" ref="cooperationRuleForm" :rules="rules" :model="cooperationForm">
           <el-form-item label="合作意向：">
             <span class="num">供货</span>
           </el-form-item>
           <el-form-item  label="服务能力：" prop="deliveryTime">
                <div>
                   <span class="title">发货时效</span>
                   <el-input-number
                   v-model="cooperationForm.deliveryTime"
                   style="margin-right:10px"
                   width="100px"
                   :min="1"
                   label="描述文字"
                   :controls="false"
                   ></el-input-number>
                   <span class="num">小时</span>
                 </div>
                 <div>
                   <span class="title">分销商数</span>
                   <span>{{cooperationForm.distributorCount || '-'}}</span>
                   <span class="tips ft-12">（截止昨天，建立了分销关系的分销商数）</span>
                 </div>
           </el-form-item>
           <el-form-item label="商品能力：">
              <div>
                 <span class="title">可分销商品</span>
                 <span>{{cooperationForm.distributeGoodCount || '-'}}</span>
                 <span class="tips ft-12">（截止昨天，可分销的spu商品数）</span>
               </div>
               <div>
                 <span class="title">月上新商品</span>
                 <span>{{cooperationForm.monthlyGoodUpdate || '-'}}</span>
                 <span class="tips ft-12">（90自然天内新增sku商品总数/3）</span>
               </div>
           </el-form-item>
           <el-form-item 
             label="合作模式：" 
             prop="cooperationMode"
             >
             <el-checkbox-group v-model="cooperationForm.cooperationMode">
               <el-checkbox :label="'1'" name="type">一件代发</el-checkbox>
               <el-checkbox :label="'2'" name="type">批量采购</el-checkbox>
             </el-checkbox-group>
           </el-form-item>
         </el-form>
 </template>
 
 <script>
 export default {
   props: {
     editCooperationFrom: {
       type: Object,
       default: ()=> {
         return {
           cooperationMode: [], // 合作模式 1: 一件代发、 2:批量采购 - 可多选，逗号分隔
           deliveryTime: 1,
           distributorCount: null,
           distributeGoodCount: null,
           monthlyGoodUpdate: null
         }
       }
     }
   },
   data() {
     return {
        cooperationForm: {
           cooperationMode: [],
           deliveryTime: '',
           distributorCount: null,
           distributeGoodCount: null,
           monthlyGoodUpdate: null
         },
         rules:{
           cooperationMode: [
             { type: 'array', required: true, message: '请至少选择一个合作模式', trigger: 'change' }
           ]
         }
     }
   },
   watch: {
     editCooperationFrom: {
       handler(v) {
         this.$set(this, 'cooperationForm', {...v})
       },
       deep: true,
       immediate: true
     }
   },
   methods: {
     method_getFormData() {
       return new Promise((resolve, reject) => {
         this.$refs.cooperationRuleForm.validate(valid => {
           if(valid) {
             let cooperationMode = this.cooperationForm.cooperationMode.join(',')
             resolve({...this.cooperationForm, cooperationMode})
           } else {
             resolve(false)
           }
         })
       })
   },
   method_reset(){
     this.$refs.cooperationRuleForm.resetFields()
   }
   }
 }
 </script>
 
 <style lang="scss" scoped>
 .num {
   margin-right: 20px;
   font-weight: bold;
 }
 .title {
   margin-right: 20px;
 }
 .tips{
   padding-left: 20px;
   color: #B8B8B8;
 }
 </style>